<template>
    <div>
        
    </div>
</template>

<script>
import router from '.././router'
export default {
    name: 'NotFound',

    mounted() {
        router.push({
            name: 'validator'
        })
    }
}
</script>

<style scoped>

</style>


